export default {
  fr: {
    a0_txt: 'Amusé.e',
    a0_sentence: 'Qui ressent de l’amusement.',
    a1_txt: 'Content.e',
    a1_sentence: 'Qui éprouve du contentement, de la satisfaction en raison de situations agréables.',
    a2_txt: 'Émerveillé.e',
    a2_sentence: 'Qui ressent un sentiment d’étonnement et d’admiration.',

    b0_txt: 'Mal à l’aise',
    b0_sentence: 'Qui ressent un inconfort dans une situation particulière ou embarrassante.',
    b1_txt: 'Triste',
    b1_sentence: 'Qui ressent du chagrin, de la peine.',
    b2_txt: 'Bouleversé.e',
    b2_sentence: 'Qui éprouve une vive émotion déstabilisante, un trouble profond.',

    c0_txt: 'Agacé.e',
    c0_sentence: 'Qui réagit à quelque chose qui lui déplaît par de l’irritabilité et de l’impatience.',
    c1_txt: 'Mécontent.e',
    c1_sentence: 'Qui ressent de l’insatisfaction, de la contrariété par rapport à quelque chose.',
    c2_txt: 'Fâché.e',
    c2_sentence: 'Qui éprouve une vive contrariété quand quelqu’un ou quelque chose ne répond pas à ses attentes.',

    d0_txt: 'Curieux.se',
    d0_sentence: 'Qui éprouve un fort désir de voir ou d’apprendre quelque chose.',
    d1_txt: 'Surpris.e',
    d1_sentence: 'Qui s’étonne positivement devant une situation plaisante.',
    d2_txt: 'Inquiet.ète',
    d2_sentence: 'Qui ressent de l’appréhension par crainte du danger ou devant l’incertitude.',
  },
  en: {
    a0_txt: 'Amused',
    a0_sentence: 'Feeling entertained.',
    a1_txt: 'Content',
    a1_sentence: 'Feeling contentment and satisfaction due to pleasant situations.',
    a2_txt: 'Amazed',
    a2_sentence: 'Having feelings of great wonder and admiration.',

    b0_txt: 'Awkward',
    b0_sentence: 'Feeling discomfort about a strange or embarrassing situation.',
    b1_txt: 'Sad',
    b1_sentence: 'Feeling sorrow or grief.',
    b2_txt: 'Overwhelmed',
    b2_sentence: 'Feeling a strongly unsettling emotion of deeply disturbed.',

    c0_txt: 'Annoyed',
    c0_sentence: 'Reacting to something that is displeasing with irritability and impatience.',
    c1_txt: 'Discontent',
    c1_sentence: 'Feeling dissatisfaction or aggravation about something.',
    c2_txt: 'Angry',
    c2_sentence: 'Feeling strong aggravation when someone or something doesn’t meet expectations.',

    d0_txt: 'Curious',
    d0_sentence: 'Feeling a strong desire to see or learn something.',
    d1_txt: 'Astonished',
    d1_sentence: 'Being surprised by an enjoyable situation.',
    d2_txt: 'Anxious',
    d2_sentence: 'Feeling apprehension for fear of danger or in a situation of uncertainty.',
  }
}



// WEBPACK FOOTER //
// ./src/components/jeu2/Visage-translation.js